<script setup lang="ts">
import { TippyDirective } from '@/helpers/tippy';

const props = defineProps<{
  id: string;
  label?: string;
}>();

const vTippy = TippyDirective;

const defaultLabel = 'Is the property a new build?';
const tooltip = 'Off-the-plan or brand new (occupied less than 12 months before first purchase)';
</script>

<template>
  <BxField v-slot="{ field }" name="isNewBuild">
    <div class="form-control is-new-build">
      <BxRadio
        v-bind="field"
        :id="id + '-is-new-build'"
        :data-test-id="id + '-is-new-build'"
        :label="props.label ?? defaultLabel"
        label-type="default"
        boolean
      />
      <button
        v-tippy="{ content: tooltip, trigger: 'mouseenter focus', placement: 'right' }"
        type="button"
        class="is-new-build__info"
        :data-test-id="id + '-is-new-build-tooltip'"
        :aria-label="tooltip"
      >
        <BxIcon name="circleInfoLight" class="h-5 w-5" />
      </button>
    </div>
  </BxField>
</template>

<style scoped>
.is-new-build {
  display: flex;
  align-items: flex-start;
  gap: 0.375rem;
}
.is-new-build__info {
  @apply text-bridgit-lightGrey;
  flex: 0 0 auto;
}
.is-new-build__info:hover {
  @apply text-bridgit-darkGrey;
}
</style>
